import { createFileRoute } from "@tanstack/react-router";
import SelfBackCosmetics from "@/features/assessments/pages/self-back-cosmetics/SelfBackCosmetics";

export const Route = createFileRoute("/$locale/$partner/_cosmetic/self-back-cosmetics")({
	component: SelfBackCosmetics,
});
